/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];


export const OrganizationStatus = {
  pending: 'pending',
  active: 'active',
  suspended: 'suspended',
} as const;
